<template>
  <div>
    <v-layout wrap justify-center style="background-color: #036917">
      <v-flex xs12 sm12 md12 lg6 xl6>
        <v-layout wrap justify-center>
          <v-flex xs1 sm1 md1 align-self-center hidden-sm-and-down>
            <v-img
              src="./../../assets/icons/caution.png"
              height="30px"
              contain
            />
          </v-flex>
          <v-flex xs12 sm11 md11 pl-2 pt-2>
            <v-layout wrap justify-center>
              <v-flex xs12 py-3>
                <span
                  style="
                    font-family: sofiaProMedium;
                    font-size: 17px;
                    color: #ffffff;
                  "
                >
                  For informations contact information center at Pothundy in
                  8330074054
                </span>
              </v-flex>
              <!-- <v-flex xs12 pt-1 style="line-height: 16px">
                <span
                  style="
                    font-family: sofiaProLight;
                    font-size: 16px;
                    color: #ffffff;
                    letter-spacing: 1px;
                  "
                >
                </span>
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  //   props: ["storage"],
  //   computed: {
  //     appNotification() {
  //       return this.$store.state.notification;
  //     },
  //   },
};
</script>
